import ShowDetailAudio from './ShowDetailAudio'

export default ShowDetailAudio
